/**
 * 自由职业者列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-if="roleId === 2"
        :to="{ path: '/task/professionalList' }"
        >用工中心</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>自由职业者列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="姓名 :">
            <el-input
              size="small"
              v-model="formInline.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="手机号 :">
            <el-input
              size="small"
              v-model="formInline.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="证件类型 :">
            <el-select
              size="small"
              v-model="formInline.idType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in idType_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="证件号 :">
            <el-input
              size="small"
              v-model="formInline.idNumber"
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="认证状态 :">
            <el-select
              size="small"
              v-model="formInline.verificationStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in verificationStatus_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="收款账号 :">
            <el-input
              size="small"
              v-model="formInline.receiveAccount"
              placeholder="请输入收款账号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="签约状态 :">
            <el-select
              size="small"
              v-model="formInline.signStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in signStatus_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="签约时间 : ">
            <el-date-picker
              size="small"
              v-model="formInline.sign_date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4" v-if="showFaceAuthStatus">
          <el-form-item label="人脸认证 :">
            <el-select
              size="small"
              v-model="formInline.faceAuthStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in faceAuthStatus_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button
        size="small"
        type="primary"
        @click="uploadVisible = true"
        v-if="shouldShowButton('upload')"
        >批量导入</el-button
      >
      <el-button
        size="small"
        @click="batchSign"
        v-if="shouldShowButton('batchSign')"
        >批量签约</el-button
      >
      <el-button
        size="small"
        @click="openPersonalAuthQrcode"
        v-if="shouldShowButton('scanSignAuth')"
        >扫码签约</el-button
      >
      <el-button
        size="small"
        @click="exportdata"
        v-if="shouldShowButton('exportData')"
        >导出数据</el-button
      >
      <el-button
        size="small"
        @click="exportagreement"
        v-if="shouldShowButton('exportAgreement')"
        >导出协议</el-button
      >
      <el-button
        size="small"
        @click="exportpath"
        v-if="shouldShowButton('exportPath')"
        >导出记录</el-button
      >
      <el-button
        size="small"
        @click="onContractMigration"
        v-if="shouldShowButton('contractMigration')"
        >导入协议</el-button
      >
      <el-button
        size="small"
        @click="onContractMigrationLog"
        v-if="shouldShowButton('contractMigrationLog')"
        >导入记录</el-button
      >
    </div>

    <!--列表-->
    <el-table
      ref="table"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column fixed prop="freelancerName" label="姓名">
      </el-table-column>
      <el-table-column prop="identityDocumentType" label="证件类型">
        <template slot-scope="scope">
          <div>
            {{ scope.row.identityDocumentType == 1 ? "身份证" : "护照" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="identityDocumentNumber"
        label="证件号"
        min-width="170"
      >
        <template slot-scope="scope">
          <div @click="xhrGetidentityDocumentNumber(scope.row.freelancerId)">
            <span style="color: #409eff; cursor: pointer">{{
              scope.row.identityDocumentNumber
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="identityPhoto"
        label="证件照"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.identityPhoto === '已上传' ? 'success' : 'danger'"
            size="small"
            effect="light"
          >
            {{ scope.row.identityPhoto }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="receiveAccount"
        label="收款账号"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="verificationStatusStr"
        label="认证状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getVerifiStatusColor(scope.row.verificationStatus),
            }"
            >{{ scope.row.verificationStatusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="signStatusStr"
        label="签约状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getSignStatusColor(scope.row.signStatus),
            }"
            >{{ scope.row.signStatusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="签约协议" min-width="90">
        <template v-slot:default="scope">
          <el-button type="text" @click="xhrGetFreelancerProtocol(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="contractSignAt"
        label="签约时间"
        show-overflow-tooltip
      >
      </el-table-column>
        <el-table-column
        v-if="showFaceAuthStatus"
        prop="faceAuthStatusStr"
        label="人脸认证"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getFaceAuthStatusColor(scope.row.faceAuthStatus),
            }"
            >{{ scope.row.faceAuthStatusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="附件"
        show-overflow-tooltip
        min-width="160"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="openAttachmentDialog(scope.row, 'view')" style="margin-right: 3px;">查看</el-link>
          <el-link type="primary" @click="openAttachmentDialog(scope.row, 'upload')">上传</el-link>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        min-width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.signStatus !== 3">
            <el-button
              size="small"
              type="primary"
              plain
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <!-- 附件管理弹窗 -->
    <el-dialog
      :title="attachmentDialog.title"
      :visible.sync="attachmentDialog.visible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div class="attachment-dialog" style="max-height: 450px; overflow-y: auto;">
        <!-- 查看模式 -->
        <template v-if="attachmentMode === 'view'">
          <div v-if="attachmentList.length > 0">
            <el-table
              :data="attachmentList"
              size="small"
              style="width: 100%;"
              :border="false"
              :striped="true"
              class="attachment-table"
            >
              <el-table-column
                prop="fileName"
                label="文件名"
                show-overflow-tooltip
                min-width="200"
              />
              <el-table-column
                label="关联任务"
                show-overflow-tooltip
                min-width="150"
              >
                <template slot-scope="scope">
                  {{ scope.row.taskId || '-' }}
                </template>
              </el-table-column>
              <el-table-column
                label="大小"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  {{ formatFileSize(scope.row.fileSize) }}
                </template>
              </el-table-column>
              <el-table-column
                label="上传时间"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  {{ formatAttachmentDateTime(scope.row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column
                label="预览"
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <div 
                    v-if="isImage(scope.row)" 
                    class="attachment-preview"
                    @click="previewAttachment(scope.row)"
                  >
                    <img 
                      :src="scope.row.fileUrl" 
                      :alt="scope.row.fileName"
                      class="attachment-thumbnail"
                    />
                  </div>
                  <el-link 
                    v-else-if="isVideo(scope.row)" 
                    type="primary" 
                    size="small" 
                    @click="previewAttachment(scope.row)"
                  >
                    <i class="el-icon-video-play"></i>
                  </el-link>
                  <span v-else style="color: #C0C4CC;">-</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-link type="primary" size="small" @click="downloadAttachment(scope.row)" style="margin-right: 12px;">下载</el-link>
                  <el-link type="danger" size="small" @click="deleteAttachment(scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else style="text-align: center; padding: 40px 0; color: #909399;">
            <i class="el-icon-folder-opened" style="font-size: 48px; margin-bottom: 16px; display: block; color: #C0C4CC;"></i>
            <p style="font-size: 14px;">暂无附件</p>
          </div>
        </template>

        <!-- 上传模式 -->
        <template v-else>
          <div style="padding: 20px;">
            <el-form :model="attachmentForm" label-width="100px">
              <el-form-item label="选择任务">
                <el-select
                  v-model="attachmentTaskId"
                  placeholder="请选择任务"
                  style="width: 320px;"
                  clearable
                >
                  <el-option
                    v-for="task in taskOptions"
                    :key="task.value"
                    :label="task.label"
                    :value="task.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="padding: 20px 0;">
              <el-upload
                class="upload-demo"
                ref="attachmentUpload"
                :action="attachmentUploadUrl"
                :data="{ freelancerId: attachmentFreelancerId, taskId: attachmentTaskId }"
                :file-list="attachmentFileList"
                :auto-upload="false"
                :on-change="handleAttachmentChange"
                :on-remove="handleAttachmentRemove"
                :limit="10"
                :on-exceed="handleAttachmentExceed"
                multiple
                drag
                style="margin-left: 100px; width: 320px;"
              >
                <i class="el-icon-upload" style="font-size: 48px; color: #8c8c8c;"></i>
                <div class="el-upload__text">
                  拖拽文件到此处上传，或<em>点击选择文件</em>
                </div>
                <div class="el-upload__tip" style="color: #909399;">
                  支持上传多种格式文件，单次最多上传10个文件
                </div>
              </el-upload>
            </div>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAttachmentDialog">取消</el-button>
        <el-button
          v-if="attachmentMode === 'upload'"
          size="small"
          type="primary"
          :loading="attachmentUploading"
          @click="submitAttachmentUpload"
          >上传</el-button
        >
      </div>
    </el-dialog>

    <!-- 附件预览弹窗 -->
    <el-dialog
      :title="previewDialog.fileName"
      :visible.sync="previewDialog.visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <div style="text-align: center;">
        <img 
          v-if="previewDialog.isImage" 
          :src="previewDialog.url" 
          :alt="previewDialog.fileName"
          style="max-width: 100%; max-height: 500px; object-fit: contain;"
        />
        <video 
          v-else 
          :src="previewDialog.url" 
          controls
          style="max-width: 100%; max-height: 500px;"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>

    <el-dialog
      :title="uploadDialog.title"
      :visible.sync="uploadDialog.visible"
      @open="uploadDialogOpen"
      width="500px"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="signForm"
        :rules="rules"
        ref="signForm"
      >
        <div
          style="
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
          "
        >
          <el-button
            size="small"
            style="margin: 0 20px"
            @click="exampleDownload"
            >模板下载</el-button
          >
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :on-remove="handleSignRemove"
            :on-change="fileOnChange"
            :file-list="signFileList"
            :auto-upload="false"
          >
            <el-button size="small" slot="trigger" type="primary"
              >选取文件</el-button
            >
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitSignTempForm('signForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="500px"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="备注" prop="remark">
          <el-input
            size="small"
            v-model="editForm.remark"
            auto-complete="off"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="查看证件照" :visible.sync="checkVisible" width="600px">
      <div class="image-container">
        <div class="image-wrapper">
          <div class="image-label">正面</div>
          <div class="thumbnail-wrapper">
            <el-image
              :src="pic_1"
              fit="contain"
              :lazy="false"
              :preview-src-list="pic_1 ? [pic_1] : []"
              class="thumbnail-image"
            >
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
                <div>加载中...</div>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
                <div>加载失败</div>
              </div>
            </el-image>
            <div class="preview-overlay" v-if="pic_1">
              <i class="el-icon-zoom-in"></i>
              <span>点击预览</span>
            </div>
          </div>
        </div>
        <div class="image-wrapper">
          <div class="image-label">反面</div>
          <div class="thumbnail-wrapper">
            <el-image
              :src="pic_2"
              fit="contain"
              :lazy="false"
              :preview-src-list="pic_2 ? [pic_2] : []"
              class="thumbnail-image"
            >
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
                <div>加载中...</div>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
                <div>加载失败</div>
              </div>
            </el-image>
            <div class="preview-overlay" v-if="pic_2">
              <i class="el-icon-zoom-in"></i>
              <span>点击预览</span>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="uploadVisible" width="500px">
      <el-upload
        class="upload-demo"
        ref="upload"
        action=""
        :on-remove="handleRemove"
        :on-change="file_on_change"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" type="primary">选取文件</el-button>
        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
      </el-upload>
      <el-image
        src="static/home/zip_info.jpg"
        style="width: 450px; height: auto; margin-top: 20px"
      ></el-image>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="uploadLoading" @click="upload_file">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="editDetailTitle"
      :visible.sync="editDetailVisible"
      width="700px"
      @close="closeDialog"
    >
      <el-form
        label-width="95px"
        :model="editDetailForm"
        :rules="rules"
        ref="editDetailForm"
      >
        <!-- 姓名和证件类型 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名：" prop="freelancerName">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.freelancerName"
                auto-complete="off"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.mobile"
                auto-complete="off"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证件类型：" prop="identityDocumentType">
              <el-select
                style="width: 220px"
                size="small"
                v-model="editDetailForm.identityDocumentType"
                placeholder="请选择"
              >
                <el-option
                  v-for="(val, index) in idType_list"
                  :label="val.label"
                  :value="val.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号：" prop="identityDocumentNumber">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.identityDocumentNumber"
                auto-complete="off"
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收款账号：" prop="receiveAccount">
              <el-input
                style="width: 220px"
                size="small"
                v-model="editDetailForm.receiveAccount"
                auto-complete="off"
                placeholder="请输入收款账号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditDetailDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitEditDetailForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="协议导入"
      :visible.sync="contractMigrationVisible"
      width="80%"
      @close="closeContractMigrationDialog"
    >
      <el-form
        :inline="true"
        :model="formInline"
        label-width="65px"
        style="padding-left: 15px; margin-bottom: 15px"
      >
        <el-form-item label="服务商 :">
          <el-input
            size="small"
            v-model="formInlineDialog.distributeCompanyName"
            placeholder="请输入服务商"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名 :">
          <el-input
            size="small"
            v-model="formInlineDialog.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="证件号 :">
          <el-input
            size="small"
            v-model="formInlineDialog.idNumber"
            placeholder="请输入证件号"
          ></el-input>
        </el-form-item>

        <el-form-item label-width="30px">
          <el-button
            size="small"
            type="primary"
            @click="fetchAllAcountFreelancer()"
            >搜索</el-button
          >
          <el-button size="small" @click="resetDialogSearch()">清空</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        size="small"
        height="500"
        :data="migrationListData"
        highlight-current-row
        v-loading="migrationLoading"
        element-loading-text="拼命加载中"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          prop="freelancerName"
          label="姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="distributeCompanyName"
          label="服务商"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="identityDocumentTypeStr"
          label="证件类型"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="identityDocumentNumber"
          label="证件号"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              class="ellipsis-text"
              @click="xhrGetidentityDocumentNumber(scope.row.freelancerId)"
            >
              <span style="color: #409eff; cursor: pointer">{{
                scope.row.identityDocumentNumber
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="receiveAccount"
          label="收款账号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="verificationStatusStr"
          label="认证状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="signStatusStr"
          label="签约状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="签约协议" show-overflow-tooltip>
          <template v-slot:default="scope">
            <el-button type="text" @click="xhrGetFreelancerProtocol(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="contractSignAt"
          label="签约时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <el-tooltip
              :content="scope.row.remark"
              placement="bottom"
              effect="light"
            >
              <span class="ellipsis">{{ scope.row.remark }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-bind:child-msg="pageparmDialog"
        @callFather="callDialogFather"
      ></Pagination>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="toggleSelection()">取消选择</el-button>
        <el-button size="small" type="primary" @click="onMigrationAll()"
          >导入全部</el-button
        >
        <el-button size="small" type="primary" @click="onMigrationSelect()"
          >导入选中</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="扫码签约"
      :visible.sync="personalAuthQrcodeVisible"
      width="460px"
      custom-class="personal-auth-qrcode-dialog"
      append-to-body
      @close="onPersonalAuthQrcodeClose"
    >
      <div
        v-loading="personalAuthQrcodeLoading"
        class="personal-auth-qrcode-wrap"
      >
        <div class="personal-auth-qrcode-tip">
          <p class="personal-auth-qrcode-tip-main">请使用手机扫描二维码</p>
          <p class="personal-auth-qrcode-tip-sub">按页面提示完成个人认证签约</p>
        </div>
        <div v-if="personalAuthQrcodeSrc" class="personal-auth-qrcode-img">
          <img :src="personalAuthQrcodeSrc" alt="签约二维码" />
        </div>
        <div
          v-else-if="!personalAuthQrcodeLoading"
          class="personal-auth-qrcode-empty"
        >
          未获取到二维码
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="personalAuthQrcodeVisible = false"
          >关闭</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          :disabled="personalAuthQrcodeLoading || !personalAuthQrcodeSrc"
          @click="downloadPersonalAuthQrcode"
          >下载二维码</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  freelancerslist,
  editremarkfreelancers,
  checkphoto,
  updateFreelancer,
  export_agreement,
  exportfreelancers,
  uploadzip,
  deleteFreelancer,
  batchSignUpload,
  batchSignTemplate,
  getAllAccountFreelancers,
  migrationFreelancers,
  getShowFaceAuthStatus,
  getPersonalAuthQrcode,
  getOmsTaskList,
  getFreelancerAttachments,
  uploadFreelancerAttachment,
  deleteFreelancerAttachment,
} from "../../api/userMG";
import { MessageBox } from "element-ui";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      migrationListData: [],
      migrationLoading: false,
      multipleSelection: [],
      contractMigrationVisible: false,
      roleId: 0,
      verificationStatus_list: [
        {
          label: "认证失败",
          value: 1,
        },
        {
          label: "未认证",
          value: 2,
        },
        {
          label: "认证成功",
          value: 3,
        },
        {
          label: "待审核",
          value: 4,
        },
        {
          label: "人脸识别成功",
          value: 5,
        },
        {
          label: "未识别",
          value: 6,
        },
      ],
      faceAuthStatus_list: [
        {
          label: "未认证",
          value: 0,
        },
        {
          label: "认证中",
          value: 1,
        },
        {
          label: "认证成功",
          value: 2,
        },
        {
          label: "认证失败",
          value: 3,
        },
        {
          label: "认证过期",
          value: 4,
        },
      ],
      isPortraitPhoto_list: [],
      isIdentityPhoto_list: [],
      idType_list: [
        {
          label: "身份证",
          value: 1,
        },
        {
          label: "护照",
          value: 2,
        },
        {
          label: "台湾通行证(台胞证)",
          value: 3,
        },
        {
          label: "港澳通行证(回乡证)",
          value: 4,
        },
      ],
      signStatus_list: [
        {
          label: "待签约",
          value: 0,
        },
        {
          label: "签约失败",
          value: 1,
        },
        {
          label: "拒签",
          value: 2,
        },
        {
          label: "签约成功",
          value: 3,
        },
        {
          label: "待人工审核",
          value: 4,
        },
        {
          label: "签约失效",
          value: 5,
        },
        {
          label: "签约中",
          value: 6,
        },
      ],
      status_list: [
        {
          label: "待录用",
          value: 0,
        },
        {
          label: "已录用",
          value: 1,
        },
        {
          label: "已拒绝",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      personalAuthQrcodeVisible: false,
      personalAuthQrcodeLoading: false,
      personalAuthQrcodeSrc: "",
      uploadDialog: {
        title: "上传自由职业者",
        visible: false,
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      uploadLoading: false, //批量导入上传加载状态
      editFormVisible: false, //控制编辑页面显示与隐藏
      checkVisible: false, //控制编辑页面显示与隐藏
      uploadVisible: false,
      editDetailTitle: "修改",
      editDetailVisible: false,
      editDetailForm: {
        id: "",
        freelancerName: "",
        mobile: "",
        identityDocumentType: "",
        identityDocumentNumber: "",
        receiveAccount: "",
      },

      title: "添加",
      editForm: {
        remark: "",
        freelancerId: "",
        token: localStorage.getItem("logintoken"),
      },
      signForm: {},
      // rules表单验证
      rules: {
        freelancerName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        identityDocumentType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        identityDocumentNumber: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码格式",
            trigger: "blur",
          },
        ],
        receiveAccount: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
        ],
      },
      fileList: [],
      signFileList: [],
      pic_1: "",
      pic_2: "",
      formInline: {
        page: 1,
        pageSize: 10,
        name: "",
        idNumber: "",
        mobile: "",
        idType: "",
        verificationStatus: "",
        faceAuthStatus: "",
        receiveAccount: "",
        signStatus: "",
        signAtStartDate: "",
        signAtEndDate: "",
        sign_date: [],
        isPortraitPhoto: "",
        isIdentityPhoto: "",
        updatedStartDate: "",
        updatedEndDate: "",
      },

      formInlineDialog: {
        page: 1,
        pageSize: 10,
        name: "",
        idNumber: "",
        distributeCompanyName: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      showFaceAuthStatus: false, // 是否展示人脸认证状态列
      // 附件管理相关
      attachmentDialog: {
        visible: false,
        title: "附件管理",
      },
      previewDialog: {
        visible: false,
        url: "",
        fileName: "",
        isImage: false,
      },
      attachmentMode: "view", // view: 查看模式, upload: 上传模式
      attachmentFreelancerId: "",
      attachmentFreelancerName: "",
      attachmentTaskId: "", // 上传时选择的任务ID
      attachmentList: [],
      attachmentFileList: [],
      attachmentUploading: false,
      attachmentUploadUrl: "/v1/freelancers/attachment/upload",
      taskOptions: [], // 任务列表选项
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      pageparmDialog: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId = JSON.parse(localStorage.getItem("user_info")).roleId;
    this.getdata(this.formInline);
    this.fetchShowFaceAuthStatus();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    fetchShowFaceAuthStatus() {
      getShowFaceAuthStatus()
        .then((res) => {
          if (res.msg == 'success') {
            this.showFaceAuthStatus = res.data;
          }
        })
        .catch(() => {});
    },
    getSignStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 0:
          return "#409EFF"; // 蓝色
        case 3:
          return "#67C23A"; // 绿色
        case 5:
          return "#909399"; // 灰色
        case 1:
        case 2:
          return "#F56C6C"; // 红色
        case 4:
          return "#E6A23C"; // 黄色
        case 6:
          return "#409EFF"; // 蓝色 - 签约中
        default:
          return "#303133"; // 默认黑色
      }
    },

    getVerifiStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 2:
          return "#409EFF"; // 蓝色
        case 3:
          return "#67C23A"; // 绿色
        case 6:
          return "#909399"; // 灰色
        case 1:
          return "#F56C6C"; // 红色
        case 4:
          return "#E6A23C"; // 黄色 - 待审核
        case 5:
          return "#E6A23C"; // 黄色
        case 7:
          return "#409EFF"; // 蓝色 - 认证中
        default:
          return "#303133"; // 默认黑色
      }
    },
    getFaceAuthStatusColor(faceAuthStatus) {
      // 人脸认证状态颜色：0/1蓝色 2绿色 3红色 4黄色
      switch (faceAuthStatus) {
        case 0:
        case 1:
          return "#409EFF"; // 蓝色
        case 2:
          return "#67C23A"; // 绿色
        case 3:
          return "#F56C6C"; // 红色
        case 4:
          return "#E6A23C"; // 黄色
        default:
          return "#303133"; // 默认黑色
      }
    },
    shouldShowButton(buttonType) {
      if (this.roleId === 2) {
        // 角色为2时不显示任何按钮
        return false;
      }
      // 其他角色显示所有按钮
      return true;
    },
    openPersonalAuthQrcode() {
      this.personalAuthQrcodeVisible = true;
      this.personalAuthQrcodeSrc = "";
      this.fetchPersonalAuthQrcode();
    },
    onPersonalAuthQrcodeClose() {
      this.personalAuthQrcodeSrc = "";
      this.personalAuthQrcodeLoading = false;
    },
    normalizePersonalAuthQrcodeData(data) {
      if (data == null || data === "") {
        return "";
      }
      if (typeof data === "string") {
        const s = data.trim();
        if (!s) {
          return "";
        }
        if (/^data:image\//i.test(s)) {
          return s;
        }
        return `data:image/png;base64,${s}`;
      }
      if (typeof data === "object") {
        const nested =
          data.qrcode ||
          data.base64 ||
          data.qrCode ||
          data.image ||
          data.qrBase64;
        return this.normalizePersonalAuthQrcodeData(nested);
      }
      return "";
    },
    fetchPersonalAuthQrcode() {
      this.personalAuthQrcodeLoading = true;
      this.personalAuthQrcodeSrc = "";
      getPersonalAuthQrcode()
        .then((res) => {
          const ok = res && (res.msg == "success" || res.code === 0);
          if (!ok) {
            this.$message.error((res && res.msg) || "获取二维码失败");
            return;
          }
          const src = this.normalizePersonalAuthQrcodeData(res.data);
          if (!src) {
            this.$message.warning("未获取到有效的二维码数据");
            return;
          }
          this.personalAuthQrcodeSrc = src;
        })
        .catch(() => {
          this.$message.error("获取二维码失败，请稍后重试");
        })
        .finally(() => {
          this.personalAuthQrcodeLoading = false;
        });
    },
    downloadPersonalAuthQrcode() {
      if (this.personalAuthQrcodeLoading) {
        return;
      }
      if (!this.personalAuthQrcodeSrc) {
        this.$message.warning("暂无可下载的二维码");
        return;
      }
      const src = this.personalAuthQrcodeSrc;
      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const ext =
            blob.type && /jpeg|jpg/i.test(blob.type) ? "jpg" : "png";
          const link = document.createElement("a");
          link.href = url;
          link.download = `签约二维码.${ext}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$message.error("下载失败，请稍后重试");
        });
    },
    fetchAllAcountFreelancer() {
      getAllAccountFreelancers(this.formInlineDialog)
        .then((res) => {
          this.migrationLoading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.migrationListData = res.data.items;
            // 分页赋值
            this.pageparmDialog.page = res.data.page;
            this.pageparmDialog.pageSize = res.data.pageSize;
            this.pageparmDialog.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.migrationLoading = false;
          this.$message.error(err);
        });
    },
    exportpath() {
      this.$router.push({ path: "/task/exportList" });
    },
    onContractMigration() {
      this.migrationListData = [];
      this.migrationLoading = true;
      this.fetchAllAcountFreelancer();
      this.contractMigrationVisible = true;
    },
    onContractMigrationLog() {
      this.$router.push({ path: "/task/contractMigrationLog" });
    },
    closeContractMigrationDialog() {
      this.contractMigrationVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    onMigrationAll() {
      this.$confirm("确定导入全部职业者?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          migrationFreelancers({
            sourceList: [],
            isAll: 1,
            totalNum: this.pageparmDialog.total,
            name: this.formInlineDialog.name,
            idNumber: this.formInlineDialog.idNumber,
            distributeCompanyName: this.formInlineDialog.distributeCompanyName,
          }) // 传递选中的任务
            .then((res) => {
              if (res.msg === "success") {
                this.$message.success(
                  "自由职业者正在导入中，请在导入记录中查看"
                );
                this.closeContractMigrationDialog();
                this.onContractMigrationLog();
              } else {
                this.$message.error(res.msg || "导入失败，请重试");
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请稍后重试");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    onMigrationSelect() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.error("请选择要导入的自由职业者");
        return;
      }

      this.$confirm("确定导入选中职业者?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id);
          migrationFreelancers({
            sourceList: ids,
            isAll: 0,
            totalNum: ids.length,
            name: this.formInlineDialog.name,
            idNumber: this.formInlineDialog.idNumber,
            distributeCompanyName: this.formInlineDialog.distributeCompanyName,
          }) // 传递选中的任务
            .then((res) => {
              if (res.msg === "success") {
                this.$message.success(
                  "自由职业者正在导入中，请在导入记录中查看"
                );
                this.closeContractMigrationDialog();
                this.onContractMigrationLog();
              } else {
                this.$message.error(res.msg || "导入失败，请重试");
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请稍后重试");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    upload_file() {
      if (this.fileList.length > 0) {
        // 设置上传加载状态，防止重复点击
        this.uploadLoading = true;
        const formData = new FormData();
        formData.append("file", this.fileList[0].raw);
        uploadzip(formData)
          .then((res) => {
            this.uploadLoading = false;
            if (res.msg == "success") {
              this.uploadVisible = false;
              this.fileList = []; // 清空文件列表
              this.$message.success(
                "自由职业者身份证正在导入中，请在导入记录中查看"
              );
              this.onContractMigrationLog();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.uploadLoading = false;
            this.$message.error("上传失败，请稍后重试");
          });
      } else {
        this.$message({
          type: "error",
          message: "请上传文件",
        });
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    file_on_change(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    },
    uploadDialogOpen() {
      this.signFileList = [];
    },
    exampleDownload() {
      batchSignTemplate()
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    handleSignRemove(file, fileList) {
      console.log(file, fileList);
    },
    fileOnChange(file, signFileList) {
      if (signFileList.length > 1) {
        signFileList.splice(0, 1);
      }
      this.signFileList = signFileList;
    },
    batchSign() {
      this.uploadDialog.visible = true;
    },
    submitSignTempForm() {
      if (this.signFileList.length == 0) {
        this.$message({
          type: "error",
          message: "请先完善信息！",
        });
        return;
      }
      this.loading = true;

      const formData = new FormData();
      formData.append("file", this.signFileList[0].raw);
      batchSignUpload(formData)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.uploadDialog.visible = false;
            this.getdata(this.formInline);
            this.$message({
              type: "success",
              message: "操作成功",
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    exportdata() {
      MessageBox.confirm(
        "您想导出所有自由职业者信息还是仅导出选中的数据？",
        "提示",
        {
          confirmButtonText: "所有数据",
          cancelButtonText: "选中数据",
          type: "warning",
          distinguishCancelAndClose: true,
        }
      )
        .then(() => {
          exportfreelancers({})
            .then((res) => {
              this.loading = false;
              if (res.msg != "success") {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              } else {
                this.$router.push({ path: "/task/exportList" });
                this.$message({
                  type: "success",
                  message: "请查看导出记录",
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("导出错误");
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let freelancerIds = [];
            const selectedRows = this.$refs.table.selection;
            selectedRows.forEach((row) => {
              freelancerIds.push(row.id);
            });
            if (freelancerIds.length > 0) {
              const params = {
                freelancerIds: freelancerIds.join(","),
              };

              exportfreelancers(params)
                .then((res) => {
                  this.loading = false;
                  if (res.msg != "success") {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  } else {
                    this.$router.push({ path: "/task/exportList" });
                    this.$message({
                      type: "success",
                      message: "请查看导出记录",
                    });
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  this.$message.error("导出错误");
                });
            } else {
              this.$message.warning("请选择要导出的数据");
            }
          }
        });
    },
    exportagreement() {
      MessageBox.confirm(
        "您想导出所有自由职业者协议还是仅导出选中的协议？",
        "提示",
        {
          confirmButtonText: "所有协议",
          cancelButtonText: "选中协议",
          type: "warning",
          distinguishCancelAndClose: true,
        }
      )
        .then(() => {
          export_agreement({})
            .then((res) => {
              this.loading = false;
              if (res.msg != "success") {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              } else {
                this.$router.push({ path: "/task/exportList" });
                this.$message({
                  type: "success",
                  message: "请查看导出记录",
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("导出错误");
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let freelancerIds = [];
            const selectedRows = this.$refs.table.selection;
            selectedRows.forEach((row) => {
              freelancerIds.push(row.id);
            });
            const params = {
              freelancerIds: freelancerIds.join(","),
            };
            if (freelancerIds.length > 0) {
              export_agreement(params)
                .then((res) => {
                  this.loading = false;
                  if (res.msg != "success") {
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  } else {
                    this.$router.push({ path: "/task/exportList" });
                    this.$message({
                      type: "success",
                      message: "请查看导出记录",
                    });
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  this.$message.error("导出错误");
                });
            } else {
              this.$message.warning("请选择要导出的数据");
            }
          }
        });
    },
    xhrGetidentityDocumentNumber(id) {
      checkphoto({ identityDocumentNumber: id })
        .then((res) => {
          this.loading = false;
          if (res.code != 0) {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.pic_1 = res.data.identityPhoto1Url;
            this.pic_2 = res.data.identityPhoto2Url;
            this.checkVisible = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    xhrGetFreelancerProtocol(row) {
      if (!row.contractAgreement) {
        this.$message.error("自由职业者服务协议未生成，请联系管理员");
        return;
      }

      if (row.signStatus != 3) {
        this.$message.error("自由职业者签约未完成，请签约成功后查看");
        return;
      }

      window.open(row.contractAgreement, "_blank");
    },
    // 获取公司列表
    getdata(parameter) {
      parameter.signAtStartDate = parameter.sign_date[0] || "";
      parameter.signAtEndDate = parameter.sign_date[1] || "";

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      freelancerslist(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("菜单加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    callDialogFather(parm) {
      this.formInlineDialog.page = parm.page;
      this.formInlineDialog.pageSize = parm.pageSize;

      this.migrationLoading = true;
      // 获取数据
      this.fetchAllAcountFreelancer();
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        name: "",
        idNumber: "",
        mobile: "",
        idType: "",
        verificationStatus: "",
        faceAuthStatus: "",
        receiveAccount: "",
        isPortraitPhoto: "",
        isIdentityPhoto: "",
        signStatus: "",
        updatedStartDate: "",
        updatedEndDate: "",
        signAtStartDate: "",
        signAtEndDate: "",
        sign_date: [],
        update_date: [],
      };
      this.getdata(this.formInline);
    },

    resetDialogSearch() {
      const page = this.formInlineDialog.page;
      const pageSize = this.formInlineDialog.pageSize;
      this.formInlineDialog = {
        page: page,
        pageSize: pageSize,
        name: "",
        idNumber: "",
        distributeCompanyName: "",
      };
      this.fetchAllAcountFreelancer();
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          editremarkfreelancers(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    submitEditDetailForm() {
      this.$refs.editDetailForm.validate((valid) => {
        if (valid) {
          updateFreelancer(this.editDetailForm).then((res) => {
            this.loading = false;
            if (res.msg == "success") {
              this.editDetailVisible = false;
              this.getdata(this.formInline);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.uploadDialog.visible = false;
    },
    handleEdit(row) {
      this.editDetailVisible = true;
      this.editDetailForm.id = row.id;
      this.editDetailForm.freelancerName = row.freelancerName;
      this.editDetailForm.identityDocumentType = row.identityDocumentType;
      this.editDetailForm.receiveAccount = row.receiveAccount;
      this.editDetailForm.identityDocumentNumber = row.identityDocumentNumber;
      this.editDetailForm.mobile = row.mobile;
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let parameter = {
            id: row.id,
          };
          deleteFreelancer(parameter).then((res) => {
            if (res.msg == "success") {
              this.getdata(this.formInline);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    closeEditDetailDialog() {
      this.editDetailVisible = false;
    },
    // ========== 附件管理方法 ==========
    // 打开附件管理弹窗
    openAttachmentDialog(row, mode = "view") {
      if (!row || !row.freelancerId) {
        this.$message.error("自由职业者信息不完整");
        return;
      }
      this.attachmentFreelancerId = row.freelancerId;
      this.attachmentFreelancerName = row.freelancerName;
      this.attachmentMode = mode;
      this.attachmentDialog.title = mode === "view" 
        ? `查看附件 - ${row.freelancerName}` 
        : `上传附件 - ${row.freelancerName}`;
      this.attachmentFileList = [];
      this.attachmentTaskId = "";
      this.attachmentDialog.visible = true;
      if (mode === "view") {
        this.loadAttachmentList();
      } else {
        this.loadTaskOptions();
      }
    },
    // 关闭附件管理弹窗
    closeAttachmentDialog() {
      this.attachmentDialog.visible = false;
      this.attachmentFreelancerId = "";
      this.attachmentFreelancerName = "";
      this.attachmentTaskId = "";
      this.attachmentList = [];
      this.attachmentFileList = [];
    },
    // 加载任务列表选项
    loadTaskOptions() {
      getOmsTaskList({ page: 1, pageSize: 100 })
        .then((res) => {
          if (res.msg === "success") {
            this.taskOptions = (res.data.items || []).map(item => ({
              value: item.taskId,
              label: `${item.taskName} (${item.taskId})`
            }));
          }
        })
        .catch((err) => {
          console.error('加载任务列表失败:', err);
        });
    },
    // 格式化文件大小（字节转可读格式）
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
    // 格式化时间戳（秒级转日期字符串）
    formatAttachmentDateTime(timestamp) {
      if (!timestamp) return "";
      const timestampMs = timestamp.toString().length <= 10 ? timestamp * 1000 : timestamp;
      const date = new Date(timestampMs);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 加载附件列表
    loadAttachmentList() {
      if (!this.attachmentFreelancerId) return;
      getFreelancerAttachments(this.attachmentFreelancerId)
        .then((res) => {
          if (res.msg === "success") {
            this.attachmentList = res.data || [];
          } else {
            this.$message.error(res.msg || "获取附件列表失败");
          }
        })
        .catch((err) => {
          this.$message.error("获取附件列表失败");
        });
    },
    // 处理文件选择变化
    handleAttachmentChange(file, fileList) {
      this.attachmentFileList = fileList;
    },
    // 处理文件移除
    handleAttachmentRemove(file, fileList) {
      this.attachmentFileList = fileList;
    },
    // 处理文件数量超限
    handleAttachmentExceed(files, fileList) {
      this.$message.warning(`最多只能上传10个文件`);
    },
    // 提交附件上传
    submitAttachmentUpload() {
      if (!this.attachmentTaskId) {
        this.$message.warning("请先选择任务");
        return;
      }
      if (this.attachmentFileList.length === 0) {
        this.$message.warning("请选择要上传的文件");
        return;
      }
      this.attachmentUploading = true;
      const formData = new FormData();
      this.attachmentFileList.forEach((file) => {
        if (file.raw) {
          formData.append("files", file.raw);
        }
      });
      formData.append("taskId", this.attachmentTaskId);
      uploadFreelancerAttachment(this.attachmentFreelancerId, formData)
        .then((res) => {
          this.attachmentUploading = false;
          if (res.msg === "success") {
            this.$message.success("上传成功");
            this.attachmentFileList = [];
            this.attachmentTaskId = "";
            this.loadAttachmentList();
          } else {
            this.$message.error(res.msg || "上传失败");
          }
        })
        .catch((err) => {
          this.attachmentUploading = false;
          this.$message.error("上传失败");
        });
    },
    // 判断是否为图片
    isImage(row) {
      if (!row.fileExtension) return false;
      const ext = row.fileExtension.replace(/^\./, '').toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
    },
    // 判断是否为视频
    isVideo(row) {
      if (!row.fileExtension) return false;
      const ext = row.fileExtension.replace(/^\./, '').toLowerCase();
      return ['mp4', 'webm', 'ogg'].includes(ext);
    },
    // 预览附件
    previewAttachment(row) {
      const fileUrl = row.fileUrl;
      this.previewDialog.url = fileUrl;
      this.previewDialog.fileName = row.fileName;
      const ext = row.fileExtension.replace(/^\./, '').toLowerCase();
      this.previewDialog.isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
      this.previewDialog.visible = true;
    },
    // 下载附件（使用minio返回的fileUrl）
    downloadAttachment(row) {
      if (!row.fileUrl) return;
      window.open(row.fileUrl);
    },
    // 删除附件
    deleteAttachment(row) {
      this.$confirm("确定要删除该附件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteFreelancerAttachment(row.attachmentId)
            .then((res) => {
              if (res.msg === "success") {
                this.$message.success("删除成功");
                this.loadAttachmentList();
              } else {
                this.$message.error(res.msg || "删除失败");
              }
            })
            .catch((err) => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // ========== 附件管理方法结束 ==========
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.dialog-table {
  margin-top: 20px;
  border: 1px solid #ebeef5;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.mb-4 {
  margin-top: 16px;
}
.image-container {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 20px;
  padding: 20px 0;
  min-height: 250px;
}
.image-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 48%;
}
.image-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}
.thumbnail-wrapper {
  position: relative;
  width: 100%;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;
  overflow: hidden;
  transition: all 0.3s;
}
.thumbnail-wrapper:hover {
  border-color: #409eff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.thumbnail-wrapper:hover .preview-overlay {
  opacity: 1;
}
.thumbnail-image {
  width: 100%;
  max-height: 250px;
  display: block;
}
.thumbnail-image /deep/ .el-image__inner {
  max-height: 250px;
  object-fit: contain;
}
.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 4px;
}
.preview-overlay i {
  font-size: 36px;
  margin-bottom: 10px;
  color: #fff;
}
.preview-overlay span {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 1px;
}
.image-slot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 250px;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
.image-slot i {
  font-size: 32px;
  margin-bottom: 8px;
  color: #c0c4cc;
}
.image-slot .el-icon-loading {
  animation: rotating 2s linear infinite;
}
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.personal-auth-qrcode-dialog >>> .el-dialog__body {
  padding: 12px 24px 8px;
}

.personal-auth-qrcode-wrap {
  min-height: 200px;
  text-align: center;
  box-sizing: border-box;
}

.personal-auth-qrcode-tip {
  margin: 0 auto 18px;
  max-width: 280px;
  text-align: center;
}

.personal-auth-qrcode-tip-main {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.45;
  color: #303133;
}

.personal-auth-qrcode-tip-sub {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}

.personal-auth-qrcode-img img {
  display: inline-block;
  max-width: 280px;
  width: 100%;
  height: auto;
  vertical-align: top;
}

.personal-auth-qrcode-empty {
  padding: 40px 12px;
  font-size: 13px;
  color: #909399;
}

/* 附件预览样式 */
.attachment-preview {
  cursor: pointer;
  display: inline-block;
}

.attachment-thumbnail {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/task/professionalList.vue